<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    {{$t('news.template.org.createdConsolidated.p1')}}
    <a class="consolidated-news" href="#"
    @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
  >{{news.textParams[0]}} {{$t('news.template.org.createdConsolidated.p2')}}</a>
    {{$t('news.template.org.createdConsolidated.p3')}}
  </div>
</template>
